import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-folder-step-two',
  templateUrl: './folder-step-two.component.html',
  styleUrls: ['./folder-step-two.component.scss']
})
export class FolderStepTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
